import { array } from 'fp-ts';
import { LocalizedText, useDialogAction } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { IconName, ActionToolbarButton } from '@optimus-web/core';
import { useDeletePropertyGroupsMutation } from '../queries';
import { DeletePropertyGroupsDialog } from './DeletePropertyGroupsDialog';

interface PropertyGroupsDeleteWrapperProps {
    selectedPropertyGroups: PortfolioEnterpriseGroupResult[];
    showText?: boolean;
    onSuccess?: () => void;
}

export const PropertyGroupsDeleteWrapper = ({
    selectedPropertyGroups,
    showText = true,
    onSuccess,
}: PropertyGroupsDeleteWrapperProps) => {
    const deletePropertyGroupsMutation = useDeletePropertyGroupsMutation();

    const deletePropertyGroups = async () => {
        await deletePropertyGroupsMutation.mutateAsync(selectedPropertyGroups);
        onSuccess?.();
    };

    const deleteAction = useDialogAction(deletePropertyGroups);
    const disabled = array.isEmpty(selectedPropertyGroups);

    return (
        <>
            <ActionToolbarButton
                variant={showText ? 'primary' : 'tertiary'}
                disabled={disabled}
                icon={IconName.Delete}
                onClick={deleteAction.handlers.handleOpen}
            >
                {showText ? <LocalizedText textKey={TextKey.Delete} /> : null}
            </ActionToolbarButton>
            {deleteAction.states.isDialogOpened && (
                <DeletePropertyGroupsDialog deleteAction={deleteAction} propertyGroups={selectedPropertyGroups} />
            )}
        </>
    );
};
